import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";
import { experienceDesignationSchema } from "./experience";

// Schema
export const customSectionSchema = itemSchema.extend({
  /** Kept in sync with `company` / `url` title line for previews and legacy data */
  name: z.string().default(""),
  description: z.string().max(90),
  date: z.string(),
  location: z.string(),
  summary: z.string(),
  keywords: z.array(z.string()).default([]),
  url: urlSchema,
  company: urlSchema.default(defaultUrl),
  companyDescription: z.string().max(90).optional().default(""),
  designations: z.array(experienceDesignationSchema).default([]),
});

// Type
export type CustomSection = z.infer<typeof customSectionSchema>;

// Defaults
export const defaultCustomSection: CustomSection = {
  ...defaultItem,
  name: "",
  description: "",
  date: "",
  location: "",
  summary: "",
  keywords: [],
  url: defaultUrl,
  company: defaultUrl,
  companyDescription: "",
  designations: [],
};
